export default __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo6-f3628241452222b3f673bfe17cddb66e.jpg";